module.exports = __webpack_public_path__ + "img/mizhi-back-second@3x.8242dff1.png";